///
/// EarthBrowser
///
/// Created by Matt Giger on 11/24/2024
/// Copyright (c) 2024 Geodata Labs
///

import {
	AlertDialog,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Loader2, Lock } from "lucide-react"

interface DatabaseLockStatusDialogProps {
	open: boolean
	hasLock: boolean
}

export function DatabaseLockStatusDialog({
	open,
	hasLock
}: DatabaseLockStatusDialogProps) {
	// Dialog shows when this tab doesn't have the database lock
	// It automatically dismisses when the lock is regained

	if (!open || hasLock) return null

	// This tab doesn't have access - show status
	return (
		<AlertDialog open={true}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle className="flex items-center gap-2">
						<Loader2 className="h-4 w-4 animate-spin" />
						Database Access Locked
					</AlertDialogTitle>
					<AlertDialogDescription>
						Another browser tab currently has access to the database.
						<br />
						<br />
						This tab will automatically gain access when it becomes the active tab, or when the other tab is closed.
						<br />
						<br />
						<span className="text-muted-foreground text-sm flex items-center gap-1.5">
							<Lock className="h-3 w-3" />
							Read-only mode - attempting to acquire access...
						</span>
					</AlertDialogDescription>
				</AlertDialogHeader>
			</AlertDialogContent>
		</AlertDialog>
	)
}

